/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description keycloak client
 */

import Keycloak, { KeycloakInitOptions } from 'keycloak-js';

interface Config {
	keycloak: string | Keycloak.KeycloakConfig;
	initOptions: KeycloakInitOptions;
}

class KeycloakClient {
	keycloak: Keycloak;
	initOptions: KeycloakInitOptions;
	constructor({ keycloak, initOptions }: Config) {
		this.initOptions = initOptions;
		this.keycloak = new Keycloak(keycloak);
	}

	isAuthenticated = (): boolean => {
		return this.keycloak.authenticated || false;
	};
}

export default KeycloakClient;
